import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const WorkExperience = ({ experiences, onRemove, onEdit, onAddNew }) => {
  return (
    <div className="form-section">
      <div className="section-header">
        <h2 className="section-title blue">Work Experience</h2>
        <button
          onClick={onAddNew}
          className="btn btn-primary"
        >
          Add Experience
        </button>
      </div>
      {experiences.map((experience, index) => (
        <div key={index} className="experience-card">
          <div className="experience-card-content">
            <div className="experience-info">
              <h3 className="experience-title">{experience.jobTitle}</h3>
              <p className="experience-company">{experience.companyName}</p>
              <p className="experience-date">
                {experience.startDate} - {experience.isCurrentJob ? 'Present' : experience.endDate}
              </p>
              {experience.location && (
                <p className="experience-location">{experience.location}</p>
              )}
              {experience.description && (
                <p className="experience-description">{experience.description}</p>
              )}
              {experience.achievements && (
                <div className="experience-achievements">
                  <h4 className="achievements-title">Key Achievements:</h4>
                  <p className="achievements-text">{experience.achievements}</p>
                </div>
              )}
            </div>
            <div className="experience-actions">
              <button
                onClick={() => onEdit(experience, index)}
                className="btn btn-secondary btn-small"
              >
                Edit
              </button>
              <button
                onClick={() => onRemove(index)}
                className="btn btn-danger btn-small"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WorkExperience; 